import { useTranslation } from "react-i18next";

import { Music } from "@/components/icons";
import { OnOffBadge } from "@/components/setup/on-off-badge";

export function DjPreviewCard({ on, pinSet }: { on: boolean; pinSet: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 bg-card p-4">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary">
        <Music className="h-5 w-5 text-muted-foreground" />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <p className="font-medium">{t("setup.preview.djTitle")}</p>
          <OnOffBadge on={on} />
        </div>
        <p className="truncate text-sm text-muted-foreground">
          {pinSet ? t("setup.preview.pinSetDesc") : t("setup.preview.noPinYet")}
        </p>
      </div>
    </div>
  );
}
